// extracted by mini-css-extract-plugin
export default {"contactWrapper":"ContactUs_contactWrapper__3fS01","detailsGroup":"ContactUs_detailsGroup__bBYTW","map":"ContactUs_map__Wbo49","socialIcons":"ContactUs_socialIcons__ow995"};